import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const SAP_BASIC_01_Schema = {
  fields: {
    no: { initial: '', label: '행 식별자' },
    newYn: { initial: 'N', label: '신규 여부' },

    createDate: { initial: '', label: '생성일자' },
    createId: { initial: '', label: '생성자 ID' },
    updateDate: { initial: '', label: '수정일자' },
    updateId: { initial: '', label: '수정자 ID' },
    mapFile: { initial: '', label: '첨부파일' },
  },
  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    search2: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    search3: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    save1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
      OrgData: (row) => row.oraData || '',
      OrgImage: (row) => Commons.EncryptAES(row.orgImage || ''),
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
